<section class="page-container bg-primary">

    <div class="container h-100">

        <div class="row h-100 d-flex justify-content-center align-items-center">

            <div class="col-md-6">

                <nav class="navbar navbar-dark bg-primary pl-0 pb-3">
                    <a class="navbar-brand d-flex align-items-center" [routerLink]="[ data.URL ] | localize">
                        <img class="logo" src="./assets/imagens/logo_branca.png">
                    </a>
                </nav>

                <div class="card border-white text-white bg-primary">

                    <div class="card-body m-2">

                        <div class="row text-center mb-4">
                            <div class="col-md-12">
                                <h1 class="display-3">
                                    {{ data.CODIGO }}</h1>
                                <h4 class="pt-3">{{ data.TITULO }}</h4>
                                <p>{{ data.DESCRICAO }}</p>
                            </div>
                        </div>

                        <div class="row text-center">
                            <div class="col-md-12">
                                <button class="btn btn-outline-light"
                                    [routerLink]="[ data.URL ] | localize">{{ data.BOTAO }}</button>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>